<template>
	<div>
		<div class="bgBox custom-tree-container" v-loading="loading">
			<div class="block">
				<div class="doctorPage managerPlan">
					<div class="selectSearch">
						<el-input size="small" placeholder="请输入菜单名称进行搜索" v-model="filterText"></el-input>
					</div>
					<div class="pdl17">
						<el-button type="primary" size="mini" @click="addFirstMemu" round>新建一级菜单</el-button>
					</div>
				</div>
				<el-tree :data="data" node-key="id" ref="tree" default-expand-all :expand-on-click-node="false" :filter-node-method="filterNode">
					<span class="custom-tree-node" slot-scope="{ node, data }" @mouseenter="mouseenter(data)" @mouseleave="mouseleave(data)">
						<span>{{ node.label }}</span>
						<div v-show="data.del">
							<i @click="append(data)" class="padding_5 textColorYellow el-icon-document-add"></i>
							<i @click="edit(data)" class="padding_5 textColorBlue el-icon-edit"></i>
							<i @click="remove(node, data)" class="padding_5 textColorRed el-icon-delete"></i>
						</div>
					</span>
				</el-tree>
				<el-dialog :title="title" :visible.sync="dialogVisible" :close-on-click-modal='false' width="60%" class="scrollbar exportFrom dialogFrom">
					<el-form label-width='100px' class="qcFrom dialogScoped" ref="setExportFrom" :rules="rules" distinguishCancelAndClose :model="exportFrom">
						<el-row v-if="isPid">
							<el-col :span="12">
								<el-form-item label="父级名称" prop="PName">
									<span class="colwhite">{{exportFrom.PName}}</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="级别" prop="TypeId">
									<span class="colwhite">{{exportFrom.TypeId}}级</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="菜单名称" prop="Title">
									<el-input size="small" style="width:240px" v-model="exportFrom.Title" placeholder="请填写菜单名称"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="展示名称" prop="ShowName">
									<el-input size="small" style="width:240px" v-model="exportFrom.ShowName" placeholder="请填写展示名称"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="权限KEY" prop="KeyName">
									<el-input v-if="isKeyName" size="small" style="width:240px" v-model="exportFrom.KeyName" placeholder="请填写权限"></el-input>
									<span v-else class="colwhite">{{exportFrom.KeyName}}</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="图标名称" prop="IconName">
									<el-input size="small" style="width:240px" v-model="exportFrom.IconName" placeholder="请填写图标名称"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="路由路径" prop="RoutePath" :rules="exportFrom.TypeId!=0?rules.RoutePath:[{ required: false, message: '请输入路由路径', trigger: 'blur' }]">
									<el-input size="small" style="width:240px" v-model="exportFrom.RoutePath"  placeholder="请填写路由路径(path)"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="页面路径" prop="FilePath">
									<el-input size="small" style="width:240px" v-model="exportFrom.FilePath" placeholder="请填写页面路径"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="排序" prop="Sort">
									<el-input size="small" style="width:240px" v-model="exportFrom.Sort" placeholder="请填写排序"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="路由名称" prop="RouteName">
									<el-input size="small" style="width:240px" v-model="exportFrom.RouteName" placeholder="请填写路由名称(name)"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<div class="dialog-footer mart25" align="center">
						<el-button type="primary" @click="preservation()">保 存</el-button>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import axios from '@/js/api'
	export default {
		data() {
			return {
				del: false,
				filterText: '',
				dialogVisible: false,
				exportFrom: {
					"Enable": 1
				},
				title: '新增菜单信息',
				rules: {
					Title: [{
						required: true,
						message: '请输入菜单名称',
						trigger: 'blur'
					}],
					ShowName: [{
						required: true,
						message: '请输入展示名称',
						trigger: 'blur'
					}],
					KeyName: [{
						required: true,
						message: '请输入权限KEY',
						trigger: 'blur'
					}],
					RoutePath: [{
						required: true,
						message: '请输入路由路径',
						trigger: 'blur'
					}],
				},
				isPid:true,
				isKeyName:true
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['loading']),
			...Vuex.mapState('admin', ['data'])
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		created() {
			this.GetModulesByGroup();
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setLoading']),
			...Vuex.mapMutations('admin', []),
			...Vuex.mapActions('admin', ['GetModulesByGroup']),
			// // 启用禁用
			// seachTab(type) {
			// 	this.exportFrom.Enable = type;
			// },
			clearExportFrom(){
				this.exportFrom ={
				  "ModuleGuid": "",
				  "Title": "",
				  "PID": "",
				  "Sort": 0,
				  "KeyName": "",
				  "TypeId": 0,
				  "RouteName": "",
				  "RoutePath": "",
				  "FilePath": "",
				  "IconName": "",
				  "Enable": 1,
				  "IsDeleted": false
				}
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			mouseenter(data) {
				this.$set(data, 'del', true)
			},
			mouseleave(data) {
				this.$set(data, 'del', false)
			},
			// 新增
			append(data) {
				this.editList('新增菜单信息',true,true)
				let datas = JSON.parse(JSON.stringify(data));
				this.clearExportFrom()
				this.exportFrom.TypeId = datas.TypeId + 1;
				this.exportFrom.ModuleGuid = '';
				this.exportFrom.PName = data.Title;
				this.exportFrom.PID = data.KeyName;
			},
			// 编辑
			edit(data) {
				this.editList('编辑菜单信息',true,false)
				let datas = JSON.parse(JSON.stringify(data));
				this.exportFrom = datas;
			},
			// 新增一级菜单
			addFirstMemu(){
				this.clearExportFrom()
				this.editList('新增菜单信息',false,true)
			},
			editList(title,isPid,isKeyName){
				this.dialogVisible = true;
				this.title = title;
				this.isPid = isPid;
				this.isKeyName = isKeyName;
			},
			// 增删改的请求
			createOrUpdateModule() {
				let _this = this;
				_this.setLoading(true);
				axios.ajaxPost('post', axios.Api.api.admin.CreateOrUpdateModule,_this.exportFrom).then(res => {
					if (res.data.StatusCode == 200) {
						_this.GetModulesByGroup();
						_this.dialogVisible = false;
						_this.$message.success('保存成功');
						_this.setLoading(false);
					}
				})
			},
			// 保存
			preservation(){
				let _this = this;
				this.$refs.setExportFrom.validate((valid) => {
					if (valid) {
						_this.createOrUpdateModule()
					} else {
						return false;
					}
				})
			},
			// 删除
			remove(node, data) {
				let _this = this;
				this.$confirm('是否确定此菜单(此菜单下的所有子菜单都将被删除)？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let datas = JSON.parse(JSON.stringify(data));
					_this.exportFrom = datas;
					_this.exportFrom.IsDeleted = true;
					_this.createOrUpdateModule();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	};
</script>
<style scoped>
	.exportTab .sliderScreeningR a {
		background: #282b32;
	}

	.exportTab .sliderScreeningR .active {
		background: #248AFD !important;
	}

	.custom-tree-container>>>.el-tree-node__expand-icon {
		position: unset !important;
	}

	.padding_5 {
		font-size: 16px;
		padding: 0 5px;
	}

	.el-icon-document-add {
		padding-left: 10px;
	}

</style>

